import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import router from '@/router';

/**
 * 非 2xx 的統一處理：401 踢回登入頁，其餘一律 reject 後端回的 `{ success, msg, data }`，
 * 呼叫端讀 `err.msg` 就拿得到中文訊息（見 AerialComparison.vue／RaAnalysis.vue 的註解）。
 */
var onRejected = function onRejected(error) {
  var _error$response, _error$message, _error$response$data, _error$response2;
  // timeout、斷線、server 沒回時沒有 error.response —— 不能直接點進去，
  // 否則這裡拋 TypeError，呼叫端看到的是 undefined 而不是「逾時」
  if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
    localStorage.removeItem('userDetail');
    router.push({
      path: 'login'
    }).catch(function (err) {
      return console.log('router push has error', err);
    });
    return;
  }
  if (error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.includes('status code 500')) return Promise.reject(error);
  return Promise.reject((_error$response$data = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data) !== null && _error$response$data !== void 0 ? _error$response$data : error);
};
axios.interceptors.response.use(function (config) {
  return config;
}, onRejected);

/**
 * 給各 api 模組建自己的 instance 用。
 *
 * **`axios.create()` 不會繼承上面那組攔截器** —— 攔截器是掛在 default instance 上的，
 * 自己建的 instance 是一份乾淨的。直接 `axios.create()` 的話 401 不會踢登入頁，
 * 後端的中文錯誤訊息也會被吃掉，呼叫端只拿得到
 * `Request failed with status code 400` 這種看了也不知道要改什麼的字。
 */
export var createRequest = function createRequest(config) {
  var instance = axios.create(config);
  instance.interceptors.response.use(function (res) {
    return res;
  }, onRejected);
  return instance;
};
export default axios;